import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Form, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import { useDispatch } from "react-redux";
import { CheckRecoveryToken, ResetPassword, forgotPassword } from "../actions/authAction";
import { REGEXP_ONLY_DIGITS_AND_CHARS } from "input-otp"
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@/components/ui/input-otp"
import Loading from "../common/Loading";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useNavigate } from "react-router-dom";
const userNameRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
const formSchema = z
  .object({
    username: z.string(),
    recoveryToken: z.string(),
    newPassword: z.string().min(8, "Password must be atleast 8 characters"),
    confirmPassword: z.string().min(8, "Password must be atleast 8 characters"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });
const ForgotPassword = ({ username, successCallback }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [userName, setUserName] = useState(username ?? '');
  const [message, setMessage] = useState(null);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      username: username ?? "",
      recoveryToken: "",
      newPassword: "",
      confirmPassword: "",
    },
  });
  useEffect(() => {
    if (userNameRegex.test(userName)) {
      setIsEmailValid(true);
    } else setIsEmailValid(false);
  }, [userName])
  const handleSubmit = () => {
    if (showOtpForm) {
      const payload = {
        Token: otpValue,
        UserName: userName
      };
      dispatch(CheckRecoveryToken(payload, (success) => {
        setShowPasswordFields(true);
        setShowOtpForm(false);
      }))
    }
    else if (showPasswordFields) {
      form.setValue("recoveryToken", otpValue);
      form.setValue("username", userName)
      form.handleSubmit(onSubmit)();
    }
    else {
      var postData = {
        userName: userName,
        captcha: '',
        captchaResponse: ''
      }
      setIsLoading(true);
      dispatch(forgotPassword(postData, (isSuccess, message) => {
        if (isSuccess) {
          setShowOtpForm(true);
        }
        setMessage(message);
        setIsLoading(false);
      }))
    }
  }
  function onSubmit(pld) {
    dispatch(ResetPassword(pld, (success) => {
      if (success) {
        successCallback && successCallback();
      }
    }))
  }
  return (
    <DialogContent className="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle>Forgot Password?</DialogTitle>
        <DialogDescription>
          {showOtpForm ? "OTP code has been sent to your email, enter the code below." : showPasswordFields ? "Enter new password to continue" : "Please enter your email used during registration."}
        </DialogDescription>
      </DialogHeader>
      {isLoading ? <Loading /> : showOtpForm ?
        <div>
          <InputOTP maxLength={4} value={otpValue} onChange={setOtpValue} pattern={REGEXP_ONLY_DIGITS_AND_CHARS}>
            <InputOTPGroup>
              <InputOTPSlot index={0} />
              <InputOTPSlot index={1} />
              <InputOTPSlot index={2} />
              <InputOTPSlot index={3} />
            </InputOTPGroup>
          </InputOTP>
        </div>
        : showPasswordFields ? <>
          <Form {...form}>
            <form>
              <FormField
                control={form.control}
                name="newPassword"
                render={({ field }) => (
                  <div className="grid gap-1">
                    <FormItem>
                      <Label className="sr-only" htmlFor="newPassword">
                        Password
                      </Label>
                      <Input
                        id="newPassword"
                        placeholder="Password"
                        type="password"
                        onChange={field.onChange}
                        disabled={isLoading}
                      />
                      {/* <EyeOffIcon />
                        <EyeIcon /> */}
                      <FormMessage />
                    </FormItem>
                  </div>
                )}
              ></FormField>
              <FormField
                control={form.control}
                name="confirmPassword"
                render={({ field }) => (
                  <div className="grid gap-1">
                    <FormItem>
                      <Label
                        className="sr-only"
                        htmlFor="confirmPassword"
                      >
                        Confirm Password
                      </Label>
                      <Input
                        id="confirmPassword"
                        placeholder="Confirm Password"
                        type="password"
                        onChange={field.onChange}
                        disabled={isLoading}
                      />
                      <FormMessage />
                    </FormItem>
                  </div>
                )}
              ></FormField>
            </form>
          </Form>
        </> :
          <div className="grid gap-4 py-4">
            <FormItem>
              <Label htmlFor="username" className="text-left">
                Email
              </Label>
              <Input
                id="username"
                value={userName}
                onChange={(e) => {
                  setMessage(null);
                  setUserName(e.target.value);
                }}
                className="col-span-3"
              />
              {!isEmailValid && userName.length > 0 && (
                <FormMessage>Please enter valid email </FormMessage>
              )}
              {message && (
                <FormMessage>{message} </FormMessage>
              )}

            </FormItem>
          </div>}
      <DialogFooter>
        <Button type="button" onClick={handleSubmit} disabled={!isEmailValid && !showOtpForm && !showPasswordFields}>
          Continue
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};

export default ForgotPassword;
